// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assests/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100vw;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat, repeat;
}

body {
  background-color: #eef2f7;
  overflow-x: hidden;
}

.dashboard1 {
  background-color: #ffe2e6 !important;
  border: none;
  border-radius: 10px;
}

.dashboard2 {
  background-color: #fff4de;
  border: none;
  border-radius: 10px;
}

.dashboard3 {
  background-color: #dcfce7;
  border: none;
  border-radius: 10px;
}

.dashboard4 {
  background-color: #f4e8ff;
  border: none;
  border-radius: 10px;
}

.cursor-pointer {
  cursor: pointer;
}

.card-width {
  width: 30rem;
}

.card-border {
  border: 1px solid #acacac;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 2px #00000040;
}

.canditate-list .defult-button-head {
  width: 20%;
}

.defult-button-head {
  width: 34%;
}

.defult-button {
  background-color: #b32523;
  color: #fff;
  border-radius: 20px;
  padding: 5px 20px;
}

.cancel-button {
  background-color: #8e8e8e;
  color: #fff;
  border-radius: 20px;
  padding: 5px 25px;
  border: none;
}

.defult-button a,
.cancel-button a,
.table-viewcustom-button a {
  color: #fff;
  text-decoration: none;
}

.defult-button:hover,
.cancel-button:hover {
  background-color: #415e95;
  color: #fff;
}

.forgot-password {
  color: #415e95;
}

.table-striped-custom {
  padding: 10px;
  margin-bottom: 0;
}

.table-striped-custom tbody tr:nth-child(even) {
  background-color: #effbff;
}

.header {
  background-color: #fff;
  top: 0;
  left: 0;
  position: fixed;

  z-index: 1;
}

.header-logo img {
  width: 100px;
  height: auto;
  padding: 5px;
}

.header-profile ul {
  display: flex;
  padding: 10px;
}

.header-profile ul li i {
  font-size: 25px;
}

.error-message {
  background-color: #f8d7da;
  color: #842029;
  border: 1px solid #f5c2c7;
  border-radius: 5px;
}

.success-message {
  background-color: #d7f8db;
  color: #208442;
  border: 1px solid #cdf5c2;
  border-radius: 5px;
}

.react-datepicker-wrapper {
  display: block !important;
}

.table-custom-button {
  background-color: #b32523;
  padding: 5px 0px;
  border: none;
  margin: 0px 5px;
  border-radius: 5px;
}

.table-custom-button:hover,
.table-custom-button:focus {
  background-color: #415e95;
}

.table-custom-button1 {
  background-color: #b3239c;
  padding: 5px 0px;
  border: none;
  margin: 0px 5px;
  border-radius: 5px;
}

.model-save-button {
  background-color: #b32523;
  border: none;
  border-radius: 5px;
}

.model-save-button:hover {
  background-color: #415e95;
}

.table-viewcustom-withouthover {
  background-color: #415e95;
  padding: 5px 0px;
  border: none;
  margin: 0px 5px;
  border-radius: 5px;
  color: #fff;
}

.spinner-container {
  position: fixed;
  /* Fixes the position relative to the viewport */
  top: 0;
  /* Start from the top */
  left: 0;
  /* Start from the left */
  width: 100vw;
  /* Full width of the viewport */
  height: 100vh;
  /* Full height of the viewport */
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  /* Flexbox for centering */
  align-items: center;
  /* Center vertically */
  justify-content: center;
  /* Center horizontally */
  z-index: 1000;
  /* Ensures it's on top of other elements */
}

.table-viewcustom-button {
  background-color: #415e95;
  padding: 5px 0px;
  border: none;
  margin: 0px 5px;
  border-radius: 5px;
}

.approval-img-text {
  width: 460px !important;
}

.table-viewcustom-button:hover,
.table-viewcustom-button:focus {
  background-color: #b32523;
}

.customDropdownStyle button {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.customDropdownStyle img {
  width: 50px;
  height: auto;
  border-radius: 30px;
}

.dropdown-item:active {
  background-color: #b32523;
  color: #fff !important;
}

.profileimage img {
  width: auto;
  height: 100px;
}

.profileimage embed {
  width: 100%;
  height: 300px;
}

.card-bg {
  background-image: linear-gradient(
    to left,
    #0db2de 0,
    #005bea 100%
  ) !important;
}

.card-bg2 {
  background-image: linear-gradient(45deg, #f93a5a, #f7778c) !important;
}

.card-bg3 {
  background-image: linear-gradient(
    to left,
    #48d6a8 0,
    #029666 100%
  ) !important;
}

.card-dashboard-border .card {
  border: none;
  border-radius: 10px;
}

.dasboard-img img {
  width: 50px;
}

.update-status {
  font-weight: 500;
}

.header-profile a {
  color: #1e2125;
  text-decoration: none;
}

.logo-text {
  display: block;
  font-family: inherit;
  color: #b53133;
  font-weight: 700;
}

.logo-text-small {
  display: none;
  font-family: inherit;
  color: #b53133;
  font-weight: 700;
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.bacdrop-spinner {
  width: 3rem;
  height: 3rem;
  z-index: 20;
}

.custom-pdf-container {
  width: "100%" !important;
  height: "200px" !important;
  overflow: "hidden" !important;
}
.hidden {
  display: none !important;
}
.custom-filter-element {
  width: 170px !important;
}

.react-datepicker__year-wrapper {
  display: block !important;
}

.custom-filter-year {
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.page_not_found_container {
  background: #fff;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page_not_found_card {
  padding: 12rem;
  box-shadow: 0px 0px 5px #ececec;
}
.not_found_code {
  font-size: 8rem;
  font-weight: bold;
}
.not_found_code_middle_digit {
  color: #c11a28;
}
.not_found_text {
  font-size: 1.2rem;
  font-weight: 500;
}

@media (max-width: 1096px) {
  .defult-button-head {
    width: 100%;
    padding: 5px;
  }
}

@media (max-width: 600px) {
  .logo-text {
    display: none;
  }

  .logo-text-small {
    display: block;
  }
}

@media (max-width: 480px) {
  .login-logo {
    width: 125px;
  }

  .header .toggle-btn {
    display: none;
  }
  .page_not_found_card {
    padding: 10px;
    box-shadow: none;
  }
}

.table_data_truncate_cell {
  white-space: "nowrap";
  overflow: "hidden";
  text-overflow: "ellipsis";
  max-width: "100%";
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yDAAuC;EACvC,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,eAAe;;EAEf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,MAAM;EACN,uBAAuB;EACvB,OAAO;EACP,wBAAwB;EACxB,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EAGzB,gBAAgB;EAChB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".bg {\r\n  background-image: url(./assests/bg.jpg);\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-position: center;\r\n  background-size: cover;\r\n  background-repeat: no-repeat, repeat;\r\n}\r\n\r\nbody {\r\n  background-color: #eef2f7;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.dashboard1 {\r\n  background-color: #ffe2e6 !important;\r\n  border: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.dashboard2 {\r\n  background-color: #fff4de;\r\n  border: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.dashboard3 {\r\n  background-color: #dcfce7;\r\n  border: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.dashboard4 {\r\n  background-color: #f4e8ff;\r\n  border: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.card-width {\r\n  width: 30rem;\r\n}\r\n\r\n.card-border {\r\n  border: 1px solid #acacac;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 1px 2px 2px #00000040;\r\n}\r\n\r\n.canditate-list .defult-button-head {\r\n  width: 20%;\r\n}\r\n\r\n.defult-button-head {\r\n  width: 34%;\r\n}\r\n\r\n.defult-button {\r\n  background-color: #b32523;\r\n  color: #fff;\r\n  border-radius: 20px;\r\n  padding: 5px 20px;\r\n}\r\n\r\n.cancel-button {\r\n  background-color: #8e8e8e;\r\n  color: #fff;\r\n  border-radius: 20px;\r\n  padding: 5px 25px;\r\n  border: none;\r\n}\r\n\r\n.defult-button a,\r\n.cancel-button a,\r\n.table-viewcustom-button a {\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n\r\n.defult-button:hover,\r\n.cancel-button:hover {\r\n  background-color: #415e95;\r\n  color: #fff;\r\n}\r\n\r\n.forgot-password {\r\n  color: #415e95;\r\n}\r\n\r\n.table-striped-custom {\r\n  padding: 10px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.table-striped-custom tbody tr:nth-child(even) {\r\n  background-color: #effbff;\r\n}\r\n\r\n.header {\r\n  background-color: #fff;\r\n  top: 0;\r\n  left: 0;\r\n  position: fixed;\r\n\r\n  z-index: 1;\r\n}\r\n\r\n.header-logo img {\r\n  width: 100px;\r\n  height: auto;\r\n  padding: 5px;\r\n}\r\n\r\n.header-profile ul {\r\n  display: flex;\r\n  padding: 10px;\r\n}\r\n\r\n.header-profile ul li i {\r\n  font-size: 25px;\r\n}\r\n\r\n.error-message {\r\n  background-color: #f8d7da;\r\n  color: #842029;\r\n  border: 1px solid #f5c2c7;\r\n  border-radius: 5px;\r\n}\r\n\r\n.success-message {\r\n  background-color: #d7f8db;\r\n  color: #208442;\r\n  border: 1px solid #cdf5c2;\r\n  border-radius: 5px;\r\n}\r\n\r\n.react-datepicker-wrapper {\r\n  display: block !important;\r\n}\r\n\r\n.table-custom-button {\r\n  background-color: #b32523;\r\n  padding: 5px 0px;\r\n  border: none;\r\n  margin: 0px 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.table-custom-button:hover,\r\n.table-custom-button:focus {\r\n  background-color: #415e95;\r\n}\r\n\r\n.table-custom-button1 {\r\n  background-color: #b3239c;\r\n  padding: 5px 0px;\r\n  border: none;\r\n  margin: 0px 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.model-save-button {\r\n  background-color: #b32523;\r\n  border: none;\r\n  border-radius: 5px;\r\n}\r\n\r\n.model-save-button:hover {\r\n  background-color: #415e95;\r\n}\r\n\r\n.table-viewcustom-withouthover {\r\n  background-color: #415e95;\r\n  padding: 5px 0px;\r\n  border: none;\r\n  margin: 0px 5px;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n}\r\n\r\n.spinner-container {\r\n  position: fixed;\r\n  /* Fixes the position relative to the viewport */\r\n  top: 0;\r\n  /* Start from the top */\r\n  left: 0;\r\n  /* Start from the left */\r\n  width: 100vw;\r\n  /* Full width of the viewport */\r\n  height: 100vh;\r\n  /* Full height of the viewport */\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  /* Semi-transparent background */\r\n  display: flex;\r\n  /* Flexbox for centering */\r\n  align-items: center;\r\n  /* Center vertically */\r\n  justify-content: center;\r\n  /* Center horizontally */\r\n  z-index: 1000;\r\n  /* Ensures it's on top of other elements */\r\n}\r\n\r\n.table-viewcustom-button {\r\n  background-color: #415e95;\r\n  padding: 5px 0px;\r\n  border: none;\r\n  margin: 0px 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.approval-img-text {\r\n  width: 460px !important;\r\n}\r\n\r\n.table-viewcustom-button:hover,\r\n.table-viewcustom-button:focus {\r\n  background-color: #b32523;\r\n}\r\n\r\n.customDropdownStyle button {\r\n  background-color: transparent !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.customDropdownStyle img {\r\n  width: 50px;\r\n  height: auto;\r\n  border-radius: 30px;\r\n}\r\n\r\n.dropdown-item:active {\r\n  background-color: #b32523;\r\n  color: #fff !important;\r\n}\r\n\r\n.profileimage img {\r\n  width: auto;\r\n  height: 100px;\r\n}\r\n\r\n.profileimage embed {\r\n  width: 100%;\r\n  height: 300px;\r\n}\r\n\r\n.card-bg {\r\n  background-image: linear-gradient(\r\n    to left,\r\n    #0db2de 0,\r\n    #005bea 100%\r\n  ) !important;\r\n}\r\n\r\n.card-bg2 {\r\n  background-image: linear-gradient(45deg, #f93a5a, #f7778c) !important;\r\n}\r\n\r\n.card-bg3 {\r\n  background-image: linear-gradient(\r\n    to left,\r\n    #48d6a8 0,\r\n    #029666 100%\r\n  ) !important;\r\n}\r\n\r\n.card-dashboard-border .card {\r\n  border: none;\r\n  border-radius: 10px;\r\n}\r\n\r\n.dasboard-img img {\r\n  width: 50px;\r\n}\r\n\r\n.update-status {\r\n  font-weight: 500;\r\n}\r\n\r\n.header-profile a {\r\n  color: #1e2125;\r\n  text-decoration: none;\r\n}\r\n\r\n.logo-text {\r\n  display: block;\r\n  font-family: inherit;\r\n  color: #b53133;\r\n  font-weight: 700;\r\n}\r\n\r\n.logo-text-small {\r\n  display: none;\r\n  font-family: inherit;\r\n  color: #b53133;\r\n  font-weight: 700;\r\n}\r\n\r\n.overlay {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: black;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1000;\r\n  top: 0px;\r\n  left: 0px;\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n}\r\n\r\n.bacdrop-spinner {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  z-index: 20;\r\n}\r\n\r\n.custom-pdf-container {\r\n  width: \"100%\" !important;\r\n  height: \"200px\" !important;\r\n  overflow: \"hidden\" !important;\r\n}\r\n.hidden {\r\n  display: none !important;\r\n}\r\n.custom-filter-element {\r\n  width: 170px !important;\r\n}\r\n\r\n.react-datepicker__year-wrapper {\r\n  display: block !important;\r\n}\r\n\r\n.custom-filter-year {\r\n  display: block;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #212529;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ced4da;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-radius: 0.25rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.page_not_found_container {\r\n  background: #fff;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.page_not_found_card {\r\n  padding: 12rem;\r\n  box-shadow: 0px 0px 5px #ececec;\r\n}\r\n.not_found_code {\r\n  font-size: 8rem;\r\n  font-weight: bold;\r\n}\r\n.not_found_code_middle_digit {\r\n  color: #c11a28;\r\n}\r\n.not_found_text {\r\n  font-size: 1.2rem;\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: 1096px) {\r\n  .defult-button-head {\r\n    width: 100%;\r\n    padding: 5px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .logo-text {\r\n    display: none;\r\n  }\r\n\r\n  .logo-text-small {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .login-logo {\r\n    width: 125px;\r\n  }\r\n\r\n  .header .toggle-btn {\r\n    display: none;\r\n  }\r\n  .page_not_found_card {\r\n    padding: 10px;\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.table_data_truncate_cell {\r\n  white-space: \"nowrap\";\r\n  overflow: \"hidden\";\r\n  text-overflow: \"ellipsis\";\r\n  max-width: \"100%\";\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
